<template>
  <div>
    <header-bar>登録情報</header-bar>
    <div class="page-block">
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">アカウント情報 - 適格請求書発行事業者情報登録</h3>
      </div>
      <div class="page-block__inner">
        <alert-view
          v-if="errors.misc"
          title="下記のエラーが発生しました。"
          :errors="[errors.misc]" />
        <div class="page-block__inner">
          <div class="profile_change_settlement-area">
            <!-- eslint-disable vue/no-v-html -->
            <div
              class="invoice_notice"
              v-html="$store.state.auth.invoice.notice" />
            <!-- eslint-enable vue/no-v-html -->
            <div class="withdrawal-head-text">
              <template v-if="isBtoB">
                正しい法人番号（登録番号）、事業者登録名でないと内容を保存できません。<br>
                ※事業者登録名は全角と半角を正しくご記入ください。<br>
              </template>
              <template v-else>
                正しい登録番号、事業者登録氏名でないと内容を保存できません。<br>
                ※事業者登録氏名は全角と半角を正しくご記入ください。<br>
              </template>
              詳しくは適格請求書発行事業者公表サイトでご確認いただけます。<br>
              <a
                href="https://www.invoice-kohyo.nta.go.jp/"
                class="c-text-link"
                target="_blank">https://www.invoice-kohyo.nta.go.jp/</a>
            </div>
          </div>
        </div>
        <div class="profile-info">
          <form
            :class="{ 'form--error': errors }"
            @submit.prevent="onSaveClicked">
            <div class="form-wrap form-wrap--profile u-no-margin-top">
              <div class="form-group">
                <div class="form-label">
                  <label
                    class="control-label"
                    for="new_mail">適格請求書発行事業者登録番号
                  </label>
                </div>
                <div class="form-item">
                  <input
                    id="registrated_number"
                    v-model="registrated_number"
                    class="form-control"
                    type="text"
                    maxlength="14"
                    placeholder="T12345678901234"
                    :disabled="$store.state.auth.invoice.disabled===true">
                  <p
                    v-if="errors['registrated_number']"
                    class="error-text">
                    {{ errors['registrated_number'][0] }}
                  </p>
                </div>
              </div>
              <div class="form-group">
                <div class="form-label">
                  <label
                    v-if="isBtoB"
                    class="control-label"
                    for="email_confirmation">適格請求書発行事業者登録名
                  </label>
                  <label
                    v-else
                    class="control-label"
                    for="email_confirmation">適格請求書発行事業者登録氏名
                  </label>
                </div>
                <div class="form-item">
                  <input
                    id="name"
                    v-model="name"
                    class="form-control"
                    type="text"
                    :disabled="$store.state.auth.invoice.disabled===true"
                    :placeholder="isBtoB?'事業者登録名':'鳴洲 太郎'">
                  <p
                    v-if="errors['name']"
                    class="error-text">
                    {{ errors['name'][0] }}
                  </p>
                </div>
              </div>
            </div>
            <div class="c-btn-wrap">
              <a
                v-show="!$store.state.auth.invoice.disabled"
                class="c-btn"
                :disabled="$store.state.auth.invoice.disabled"
                @click.prevent="onSaveClicked">
                内容を保存
                <span class="c-btn__icon-arrow"></span>
              </a>
              <router-link
                :to="{ name: 'profile' }"
                class="c-btn c-btn--back c-btn--back-left">
                戻る
                <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
              </router-link>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBar from '../HeaderBar'
import AlertView from './AlertView'

export default {
  name: 'ProfileEditInvoice',
  components: { HeaderBar, AlertView },
  data() {
    return {
      registrated_number: '',
      name: '',
      errors: {
      },
    }
  },
  mounted() {
    this.fetchItem()
  },
  methods: {
    async fetchItem() {
      const response = await window.axios.get(`/api/client/users/${this.$store.state.auth.id}`)
      if (response.data.company.invoice && response.data.company.invoice.status === 1) {
        // 登録済みの場合は「アカウント情報」に飛ばす
        await this.$router.push({ name: 'profile' })
      }
    },
    async onSaveClicked() {
      window.scrollTo(0, 0)
      try {
        const params = { name: this.name, registrated_number: this.registrated_number }
        await window.axios.post('/api/client/invoice-taxpayer', params)
        await this.$router.push({ name: 'profile' })
      } catch ({ response }) {
        const { errors } = response.data
        this.errors = errors
      }
    },
  },
}
</script>

<style scoped>
.invoice_notice{
  color:#f00;
  font-weight:bold;
}
</style>
